import red from "assets/redtshirt.png";
import black from "assets/blacktshirt.png";
import white from "assets/whitetshirt.png";
import orange from "assets/orangetshirt.png";
import aqua from "assets/aquatshirt.png";
import yellow from "assets/yellowtshirt.gif";
import mate from "assets/mateyellowtshirt.png";
import smiley from "assets/smileytshirt.png";
import rainbow from "assets/rainbowtshirt.png";
export const product =[
    {ID:1, pname:"Tshirt", color:"Red", price:500,Quality:"cotton",design:"Casual", ImgUrl:red ,quantity:0},
    {ID:2, pname:"Tshirt", color:"Black", price:600,Quality:"cotton",design:"Casual", ImgUrl:black ,quantity:0},
    {ID:3, pname:"Tshirt", color:"White", price:400,Quality:"cotton",design:"Casual", ImgUrl:white ,quantity:0},
    {ID:4, pname:"Tshirt", color:"Orange", price:1500,Quality:"cotton",design:"Casual", ImgUrl:orange ,quantity:0},
    {ID:5, pname:"Tshirt", color:"Aqua", price:550,Quality:"cotton",design:"Casual", ImgUrl:aqua ,quantity:0},
    {ID:6, pname:"Tshirt", color:"Yellow", price:500,Quality:"cotton",design:"Casual", ImgUrl:yellow ,quantity:0},
    {ID:7, pname:"Tshirt", color:"Mate Yellow", price:900,Quality:"cotton",design:"Casual", ImgUrl:mate ,quantity:0},
    {ID:8, pname:"Tshirt", color:"Smiley", price:2000,Quality:"cotton",design:"Casual", ImgUrl:smiley ,quantity:0},
    {ID:9, pname:"Tshirt", color:"Rainbow", price:2500,Quality:"cotton",design:"Casual", ImgUrl:rainbow ,quantity:0}
];